'use strict'
import loginApi from './login';//登录模块api
import authorityApi from './authority';//用户模块api
import publicApi from './public';//公共api
import bulkPayApi from './bulkPay';//打款api
import homeApi from './home';//打款api
import indivvidualApi from './indivvidual';//个体信息api
import rechargesApi from './recharges';//充值api
import missionSquareApi from './missionSquare';//任务api
import invoiceApi from './invoice';//发票api
import signApi from './sign';//签约api
import merchantsApi from './merchants';//商户api
import exportApi from './export';//导出api
import executivesApi from './executives';//董监高api


export {
    loginApi,
    authorityApi,
    publicApi,
    bulkPayApi,
    homeApi,
    indivvidualApi,
    rechargesApi,
    missionSquareApi,
    invoiceApi,
    signApi,
    merchantsApi,
    exportApi,
    executivesApi
};
